<template>
    <div class="toggle form-group">
        <input type="checkbox" v-model="toggled" @change="handleInput" id="temp">
        <label for="temp">{{ title }}</label>
        <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>
    </div>
</template>

<script>
    export default {
        name: 'vCheckbox',
        props: {
            name:{
                default: ''
            },
            title: {
                default: ''
            },
            value: {
                default: ''
            }
        },
        data() {
            return{
                toggled: this.value,
                errors: {}
            }
        },
        mounted() {
            this.$emit('input', this.value === null ? '' : this.value)
            Event.listen('errors', (e) => {
                this.errors = e
            })
        },
        watch: {
          value: function(newVal, oldVal) { // watch it
            this.toggled = newVal
          }
        },
        methods: {
            handleInput (e) {
                this.$emit('input', this.content)
                this.$delete(this.errors, this.name)
            }
        }
    };
</script>

<style scoped> 
   @import url(https://fonts.googleapis.com/css?family=Montserrat);


    .toggle {
      margin-top: 30px;
    }
    .toggle input[type="checkbox"] {
      display: none;
    }
    .toggle label {
      color: #333333;
      position: relative;
      margin-left: 80px;
    }
    .toggle input[type="checkbox"] + label::before {
      content: " ";
      display: block;
      height: 18px;
      width: 45px;
      border: 1px solid #70a6b2;
      border-radius: 9px;
      position: absolute;
      top: 0px;
      left: -65px;
      background: #70a6b2;
    }
    .toggle input[type="checkbox"] + label::after {
      content: " ";
      display: block;
      height: 30px;
      width: 30px;
      border: 1px solid #114753;
      border-radius: 50%;
      position: absolute;
      top: -6px;
      left: -75px;
      background: #114753;
      transition: all 0.3s ease-in;
    }
    .toggle input[type="checkbox"]:checked + label::after {
      left: -40px;
      transition: all 0.3s ease-in;
    }

</style>
